import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/AddNews.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';

const AddSuccessStoryPage = () => {

    const initialFormData = {
        title:'',
        field_name: '',
        summary: '',
        body: '',
        field_image_success_story:'',
        // Kept empty: the create API still counts placements. Course
        // associations go through `courses` (entity_placement rows with product_id).
        placements: [],
        courses: [{ product_id: '', placement_sort_order: '1' }],
        url_alias: '',
    };

    const [formData,setFormData] =useState(initialFormData);
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [showSummary, setShowSummary] = useState(false);
    const [useRichEditor, setUseRichEditor] = useState(true);
    const [PreviewFields, setPreviewFields] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);

    const [imageUploadError, setImageUploadError] = useState('');
    const [tempImage, setTempImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null); 
    const [courses, setCourses] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const domainName = window.location.hostname;
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');  
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;

    useEffect(() => {
        Promise.all([
            getcourselist(),
            getuserloggedinroles(),
        ]).then(() => {
            setIsLoading(false);
        })
    }, []);

    // Course products that have a linked course page (so the selection can be
    // saved as a placement on that page). Rows: { product_id, product_name, ... }.
    async function getcourselist() {
        try {
            const response = await fetch(
                app_url+'smwwcommerceproduct/getcourseproducts',
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({}),
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCourses(responsedata.data.result || []);
            }
        } catch (err) {

        }
    }

    async function getuserloggedinroles() {
        try {
        setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
        }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    }

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const handleTempImageChange = (e) => {
        const files = Array.from(e.target.files);
        const file = files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024;
        const errors = [];

        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        if (errors.length > 0) {
            const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>`;
            setImageUploadError(errorHTML);
            e.target.value = '';
            setTempImage(null);
            return;
        }

        setImageUploadError(''); // Clear previous error
        const objectUrl = URL.createObjectURL(file);
        setTempImage({
            file,
            preview: objectUrl
        });
    };
    const handleImageUploadClick = () => {
        if (tempImage) {
            setSelectedImage(tempImage);
            setFormData(prev => ({
            ...prev,
            field_image_success_story: tempImage.file
            }));
            setImageUploadError(''); // Clear error on successful upload
        }
    };

    // Remove image
    const removeImage = () => {
        setSelectedImage(null);
        setTempImage(null);
        setFormData(prev => ({
            ...prev,
            field_image_success_story: "",
        }));
    };

    const imageValue = selectedImage ? selectedImage.file : formData.field_image_success_story;
    const fileName =
        imageValue && typeof imageValue === "object" && imageValue.name
        ? imageValue.name
        : typeof imageValue === "string"
        ? imageValue.split("/").pop()
        : "";

    const formatFileSize = (size) => {
        if (size < 1024) return size + " Bytes";
        else if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
        else return (size / (1024 * 1024)).toFixed(2) + " MB";
    };

    const getImageSrc = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value; // already a URL from backend
        if (value.preview) return value.preview; // wrapper object { file, preview, name }
        if (value.file && value.file instanceof File) return URL.createObjectURL(value.file); // has file
        if (value instanceof File) return URL.createObjectURL(value); // plain File object
        return "";
    };

    // COURSE section handlers (same shape as EditSuccessStoryPage).
    const handleAddCourse = () => {
        setFormData((prev) => ({
            ...prev,
            courses: [...(prev.courses || []), { product_id: '', placement_sort_order: '1' }],
        }));
    };

    const handleDeleteCourse = (index) => {
        setFormData((prev) => ({
            ...prev,
            courses: prev.courses.filter((_, i) => i !== index),
        }));
    };

    const handleCourseChange = (index, field, value) => {
        setFormData((prev) => {
            const updated = [...prev.courses];
            updated[index] = { ...updated[index], [field]: value };
            return { ...prev, courses: updated };
        });
    };

    const handlePreviewClick = () => {
        const {
        title,
        field_name,
        summary,
        body,
        field_image_success_story,
        } = formData;

        const newErrors = {};
        if (!title.trim()) {
            newErrors.title = "Title field is required.";
            window.scrollTo(0, 0);
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setPreviewFields(false);
            return;
        }

        const cleanedSummary = cleanHtmlOutput(summary);
        const cleanedBody = cleanHtmlOutput(body);

        const hasSummary = cleanedSummary && cleanedSummary.trim() !== '';
        let trimmedHtml = '';

        if (hasSummary) {
            trimmedHtml = cleanedSummary;
        } else if (cleanedBody.includes('<!--break-->')) {
            trimmedHtml = cleanedBody.split('<!--break-->')[0];
        } else {
            const tmp = document.createElement('div');
            tmp.innerHTML = cleanedBody;
            trimmedHtml = '';
        }

        setPreviewData({
            title,
            field_name,
            summary: hasSummary ? cleanedSummary : '',
            trimmed: trimmedHtml,
            body: cleanedBody,
            field_image_success_story,
        });

        setErrors({});
        setPreviewFields(true);
        window.scrollTo(0, 0);
    };

    const cleanHtmlOutput = (html) => {
        if (!html || typeof html !== 'string') return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : cleaned.trim();
    };

    const handleEditorChange = (e) => {
        setFormData(prev => ({
            ...prev,
            body: e.target.value
        }));
    };

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        setFormData(prev => {
        if (type === "checkbox" && Array.isArray(prev[name])) {
            return {
            ...prev,
            [name]: checked
                ? [...prev[name], value]
                : prev[name].filter(v => v !== value),
            };
        }
        return {
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        };
        });
    };
    
    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) {
            newErrors.title = "Title field is required.";
            window.scrollTo(0, 0);
        }
        return newErrors;
    };

    const inputStyle = {
        title: {
        border: errors.title ? '2px solid red' : '1px solid #777'
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();
        setErrors(validationErrors);
        setPreviewFields(false);
        setPreviewFields(false);
        setImageUploadError("");
        window.scrollTo(0, 0);

        if (Object.keys(validationErrors).length > 0) return;

        // 1. Show "Saving..." on the submit button and disable interactive elements
        setFormData(prevState => ({
            ...prevState,
            button_name: "Saving..."
        }));
        setDisabled(true);

        const cleanedSummary = cleanHtmlOutput(formData.summary);
        const cleanedBody = cleanHtmlOutput(formData.body); // Fallback to state body

        // 2. Instantiate FormData
        const postData = new FormData();

        // 3. Append media files to postData (Check if state exists and holds a valid browser File)
        if (selectedImage && selectedImage.file) {
            postData.append('field_image_success_story', selectedImage.file);
        }

        // 4. Normalize array-based fields so they don't break on the backend 
        const updatedFormData = {
            ...formData,
            summary: cleanedSummary,
            body: cleanedBody
        };

        console.log("Submitted data:", updatedFormData);
        postData.append('formData', JSON.stringify(updatedFormData));

        try {
            // 5. Send POST request (replace fetch url wrapper as needed)
            const response = await fetch(app_url + 'successstory/addnewsuccessstory', { // Adjust backend path if needed
                method: 'POST',
                body: postData,
            });

            const data = await response.json();

            if (data.data && data.data.msg === "Success") {
                setFormData(initialFormData);
                setDisabled(false);

                // Redirect smoothly to view details
                navigate('/manage-success-stories', { state: { message: data.data.result } });
            } else {
                // Re-enable in case backend validation issues/errors bubble up
                setErrors({ save: (data.data && data.data.text) || data.message || "The success story could not be saved." });
                window.scrollTo(0, 0);
                setDisabled(false);
                setFormData(prevState => ({
                    ...prevState,
                    button_name: "Save"
                }));
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            setDisabled(false);
            setFormData(prevState => ({
                ...prevState,
                button_name: "Save"
            }));
        }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>Create Success Story</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <h1>Create Success Story</h1>
                        <div className="agency-news-create-preview">
                            {PreviewFields && (
                            <>
                                <div
                                    className="messages status"
                                    style={{
                                        background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
                                        backgroundPosition: '10px 10px',
                                    }}
                                >
                                    The trimmed version of your post shows what your post looks like when promoted
                                    to the main page or when exported for syndication.
                                    <span>
                                        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                                        fine-tune where your post gets split.
                                    </span>
                                </div>

                                <div className="preview-container">
                                    {/* Trimmed version */}
                                    <div className="preview-trimmed">
                                        <h4 className="preview-heading">
                                            Preview trimmed version
                                        </h4>
                                        <div className="email-teaser">
                                            <h2 className="email-title">
                                                <span style={{color: "#2C99D2"}}>{previewData?.title}</span>
                                            </h2>
                                            {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
                                                <div
                                                    className="preview-body-content"
                                                    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {/* Full version */}
                                    <div className="preview-full">
                                        <h4 className="preview-heading">
                                            Preview full version
                                        </h4>
                                        <div className="email-teaser">
                                            <h2 className="email-title"></h2>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                __html: previewData.body || '',
                                                }}
                                            />
                                            <div className="email-meta">
                                                {previewData.field_name && (
                                                    <p><strong>Name:</strong> {previewData.field_name}</p>
                                                )}
                                                {previewData.field_image_success_story && (
                                                    <div>
                                                        <strong>Image:</strong><br />
                                                        <img 
                                                        src={getImageSrc(previewData.field_image_success_story)} 
                                                        alt="Preview" 
                                                        style={{ height: "100px", width: "100px", marginTop: "5px" }} 
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            )}
                        </div>

                        <div className="agency-news-create-container">
                            {Object.values(errors).some(msg => !!msg) && (
                                <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                >
                                    <ul>
                                        {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                            <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <div className="form-item">
                                        <label htmlFor="edit-title">
                                            Title  
                                            <span className="form-required" title="This field is required.*">*</span>
                                        </label>
                                        <input
                                            type="text" 
                                            id="edit-title" 
                                            name="title"
                                            size={60}
                                            maxLength={255}
                                            onChange={handleChange} 
                                            value={formData.title}
                                            style={inputStyle.title}
                                        />
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="edit-field-name">
                                            Name
                                        </label>
                                        <input 
                                            className="text-full form-text" 
                                            type="text" 
                                            id="edit-field-name" 
                                            name="field_name" 
                                            size={60} 
                                            maxLength={255}
                                            value={formData.field_name}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div>
                                        <label>Image</label>
                                        {imageUploadError && (
                                            <div
                                                className="set-message-error error-message-padding"
                                                style={{
                                                background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                                }}
                                            >
                                                <div 
                                                    style={{ color: '#8c2e0b',
                                                        backgroundColor: '#fef5f1',
                                                        marginBottom: '10px', 
                                                        width: '80%',
                                                        borderRadius: '5px' 
                                                    }}
                                                    dangerouslySetInnerHTML={{ __html: imageUploadError }}
                                                    >                           
                                                </div>
                                            </div>
                                        )}
                                        {selectedImage ? (
                                            // Case 1: New image selected
                                            <div className="edit-agent-image-container">
                                                <img alt="Uploaded" src={selectedImage.preview} width="90" height="100" />
                                                <div className="image-info">
                                                    <img
                                                        className="file-icon"
                                                        alt="File icon"
                                                        src={getFileIcon(selectedImage.file.name)}
                                                    />
                                                    <a
                                                        href={selectedImage.preview}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="image-name-link"
                                                    >
                                                        {selectedImage.file.name}
                                                    </a>
                                                    <span className="image-size">
                                                        ({(selectedImage.file.size / 1024).toFixed(2)} KB)
                                                    </span>
                                                </div>
                                            </div>
                                        ) : formData.field_image_success_story ? (
                                            // Case 2: Image already saved (URL string from backend)
                                            <div className="edit-scout-report-image-container">
                                                <img
                                                    alt="Uploaded"
                                                    src={formData.field_image_success_story}
                                                    width="90"
                                                    height="100"
                                                />
                                                <div className="image-info">
                                                    <a
                                                        href={formData.field_image_success_story}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="image-name-link"
                                                    >
                                                        {fileName}
                                                    </a>
                                                </div>
                                            </div>
                                        ) : (
                                            // Case 3: No image yet → show upload input
                                            <div>
                                                <input
                                                    type="file"
                                                    id="edit-agent-photo-upload"
                                                    name="field_image_success_story"
                                                    accept="image/*"
                                                    onChange={handleTempImageChange}
                                                />
                                                <input
                                                    type="button"
                                                    value="Upload"
                                                    className="form-submit"
                                                    onClick={handleImageUploadClick}
                                                />
                                            </div>
                                        )}

                                        {(selectedImage || formData.field_image_success_story) && (
                                            <input
                                                type="button"
                                                value="Remove"
                                                className="form-submit"
                                                onClick={removeImage}
                                            />
                                        )}

                                        {!formData.field_image_success_story && !selectedImage && (
                                            <div className="description">
                                                Files must be less than <b>128 MB</b>.<br />
                                                Allowed file types: <b>png gif jpg jpeg</b>.
                                            </div>
                                        )}
                                        <div style={{clear: "both"}}></div>
                                    </div>

                                    <div>
                                        <div>
                                            {showSummary && (
                                                <div className="form-item">
                                                    <label htmlFor="create_summary">
                                                        Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                                    </label>
                                                    <>
                                                        <Editor 
                                                        value={formData.summary} 
                                                        onChange={(e) => {
                                                            const newValue = e?.target?.value || '';
                                                            setFormData((prev) => ({ ...prev, summary: newValue }));
                                                        }}
                                                        />
                                                    </>
                                                    <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                                </div>
                                            )}
                                    
                                            <div className="form-item">
                                                <label htmlFor="create_body">
                                                    Body
                                                    {!showSummary && (
                                                        <span>
                                                            (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                                Edit Summary
                                                            </a>)
                                                        </span>
                                                    )}
                                                </label>
                                                <>
                                                    {useRichEditor ? (
                                                        <> 
                                                            <Editor 
                                                                containerProps={{ style: { resize: 'vertical', height:'300px' } }} 
                                                                value={formData.body} 
                                                                onChange={handleEditorChange}

                                                            />  
                                                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                                Switch to plain text editor
                                                            </a>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <textarea
                                                                id="create_body"
                                                                rows="20"
                                                                value={formData.body} 
                                                                // onChange={e => onEditorChange('body', e.target.value)}
                                                                onChange={(e) => setFormData((prev) => ({ ...prev, body: e.target.value })) } 
                                                            />
                                                            <div 
                                                                className="grippie" 
                                                                style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                            >
                                                            </div>
                                                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                                Switch to rich text editor
                                                            </a>
                                                        </>
                                                    )}
                                                </>
                                            </div>
                                        </div>

                                        <fieldset 
                                            className="form-wrapper" 
                                            style={{
                                                border: "1px solid #ccc", 
                                                padding: "15px 20px", 
                                                marginBottom: "15px",
                                                fontFamily: "sans-serif"
                                            }}
                                        >

                                            <div className="editprofile-fieldset-wrapper">
                                                <label>COURSE</label>
                                                <table
                                                    style={{
                                                        width: "100%",
                                                        borderCollapse: "collapse",
                                                        backgroundColor: "white",
                                                        border: "1px solid #ccc",
                                                        fontSize: "11px"
                                                    }}
                                                    className="courses-table"
                                                >
                                                    <thead>
                                                        <tr style={{ backgroundColor: "#e1e2dc", borderBottom: "1px solid #ccc" }}>
                                                            <th style={{ 
                                                                width: '70%', 
                                                                padding: '6px 10px', 
                                                                textAlign: 'left', 
                                                                fontWeight: 'bold', 
                                                                color: '#333',
                                                                textTransform: 'uppercase',
                                                                borderRight: '1px solid #ccc'
                                                            }}>
                                                                Course
                                                            </th>
                                                            <th style={{ 
                                                                width: '15%', 
                                                                padding: '6px 10px', 
                                                                textAlign: 'left', 
                                                                fontWeight: 'bold', 
                                                                color: '#333',
                                                                textTransform: 'uppercase',
                                                                borderRight: '1px solid #ccc'
                                                            }}>
                                                                Sort Order
                                                            </th>
                                                            <th style={{ 
                                                                width: '15%', 
                                                                padding: '6px 10px', 
                                                                textAlign: 'center', 
                                                                fontWeight: 'bold', 
                                                                color: '#333',
                                                                textTransform: 'uppercase'
                                                            }}>
                                                                Delete
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(formData.courses || []).map((course, index) => (
                                                            <tr key={index} style={{ borderBottom: index < formData.courses.length - 1 ? "1px solid #ccc" : "none" }}>
                                                                {/* Course Select Column */}
                                                                <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
                                                                    <select
                                                                        className="course-select"
                                                                        name={`course_product_${index}`}
                                                                        value={course.product_id}
                                                                        onChange={(e) =>
                                                                            handleCourseChange(index, 'product_id', e.target.value)
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                            padding: "4px",
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "2px",
                                                                            fontSize: "12px",
                                                                            boxSizing: "border-box"
                                                                        }}
                                                                    >
                                                                        <option value="">Select a course</option>
                                                                        {courses.length > 0 && (
                                                                            <>
                                                                                {courses.map((item) => (
                                                                                    <option key={item['product_id']} value={item['product_id']}>
                                                                                        {item['product_name']}
                                                                                    </option>
                                                                                ))}
                                                                            </>
                                                                        )}
                                                                    </select>
                                                                </td>

                                                                {/* Sort Order Select Column */}
                                                                <td style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #ccc' }}>
                                                                    <select
                                                                        name={`course_sort_order_${index}`}
                                                                        className="adduser-form-select"
                                                                        value={course.placement_sort_order}
                                                                        onChange={(e) =>
                                                                            handleCourseChange(index, 'placement_sort_order', e.target.value)
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                            maxWidth: "60px",
                                                                            padding: "4px",
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "2px",
                                                                            fontSize: "12px"
                                                                        }}
                                                                    >
                                                                        {[...Array(50)].map((_, i) => (
                                                                            <option key={i + 1} value={i + 1}>
                                                                                {i + 1}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </td>

                                                                {/* Delete Button Column */}
                                                                <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                    <button
                                                                        type="button"
                                                                        className='quick-links-reg-button form-submit'
                                                                        onClick={() => handleDeleteCourse(index)}
                                                                        
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                                {/* Add Course Link */}
                                                <div style={{ marginTop: "12px" }}>
                                                    <a
                                                        className="add-course-link"
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleAddCourse();
                                                        }}
                                                        style={{
                                                            color: "#0071B8",
                                                            textDecoration: "none",
                                                            fontWeight: "bold",
                                                            fontSize: "12px"
                                                        }}
                                                        onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                                                        onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
                                                    >
                                                        + Add
                                                    </a>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <div className="form-item">
                                            <label htmlFor="edit-path-alias">
                                                URL alias
                                            </label>
                                            <input
                                                type="text"
                                                id="edit-path-alias"
                                                name="url_alias"
                                                onChange={handleChange}
                                                value={formData.url_alias}
                                            />
                                            <p className="description" style={{marginTop: "5px"}}>Optionally specify an alternative URL by which this content can be accessed. For example, type "about" when writing an about page.
                                            Use a relative path and don't add a trailing slash or the URL alias won't work.</p>
                                        </div>

                                    </div>
                                    <div className="form-actions form-wrapper" id="create-actions">
                                        <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp;
                                        <input 
                                            type="button" 
                                            id="edit-preview"  
                                            value="Preview" 
                                            className="form-submit" 
                                            onClick={()=> {
                                            handlePreviewClick();
                                            }}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};
export default AddSuccessStoryPage;